import React, {useState} from 'react'
import styled from '@emotion/styled'

import GoodReview from '../GoodReview'
import AddGoodReview from '../AddGoodReview'

const GoodReviewsRoot = styled.div`
`

const ReviewsHeader = styled.h2`
  margin: 13px 0 7px 0;
  color: #333;
  font: 15px/1.4 Merriweather, serif;
  font-weight: 400;
`

const ReviewItems = styled.div`
  padding-bottom: 10px;
`

const Empty = styled.div`
  font-weight: 500;
`

const Action = styled.div`
  cursor: pointer;
  display: inline-block;
  color: #2d9831;
  font-weight: 600;
  font-size: 12px;
  text-decoration: none;
  border-bottom: 1px solid #78b97a;
`

const GoodReviews = ({
  good,
  compact = false
}) => {
  const [showForm, setShowForm] = useState(false)

  const content = good.reviews.length > 0
    ? <ReviewItems>{good.reviews.map(item => <GoodReview key={item.id} {...item} compact={compact}/>)}</ReviewItems>
    : <Empty>Отзывов пока нет. Вы можете добавить первый!</Empty>

  return <GoodReviewsRoot>
    <ReviewsHeader>Отзывы</ReviewsHeader>
      {content}
      {!showForm && <Action onClick={() => setShowForm(true)}>Добавить отзыв</Action>}
      {showForm && <AddGoodReview good={good}/>}
  </GoodReviewsRoot>
}

export default GoodReviews
